import { Reveal, RevealGroup, RevealItem } from "@/components/site/Reveal";
import { useT } from "@/lib/i18n";

const CHAPTER_KEYS = [
  { no: "01", titleKey: "manifesto.c1.title", bodyKey: "manifesto.c1.body" },
  { no: "02", titleKey: "manifesto.c2.title", bodyKey: "manifesto.c2.body" },
  { no: "03", titleKey: "manifesto.c3.title", bodyKey: "manifesto.c3.body" },
  { no: "04", titleKey: "manifesto.c4.title", bodyKey: "manifesto.c4.body" },
];

const Manifesto = () => {
  const { t } = useT();
  return (
    <section
      data-testid="manifesto-section"
      className="relative py-24 md:py-36 bg-ark-ink text-white overflow-hidden"
    >
      <div className="absolute -top-32 -right-24 h-96 w-96 rounded-full bg-ark-sky/25 blur-[120px]" />
      <div className="absolute -bottom-32 -left-24 h-96 w-96 rounded-full bg-ark-teal/25 blur-[120px]" />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <div className="flex items-center gap-3 text-ark-yellow">
            <span className="h-px w-10 bg-ark-yellow/70" />
            <span className="font-display font-semibold uppercase tracking-[0.3em] text-xs">
              {t("manifesto.eyebrow")}
            </span>
          </div>
          <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl lg:text-7xl leading-[1.02] max-w-4xl">
            {t("manifesto.headline1")}
            <span className="text-rainbow"> {t("manifesto.headline2")}</span>
          </h2>
        </Reveal>

        <RevealGroup className="mt-16 md:mt-24 grid md:grid-cols-2 gap-x-14 gap-y-14">
          {CHAPTER_KEYS.map((c) => (
            <RevealItem key={c.no}>
              <div
                data-testid={`manifesto-chapter-${c.no}`}
                className="group border-t border-white/15 pt-7"
              >
                <div className="flex items-baseline gap-5">
                  <span className="font-display font-bold text-2xl md:text-3xl text-ark-yellow tabular-nums">
                    {c.no}
                  </span>
                  <div>
                    <h3 className="font-display font-bold text-2xl md:text-3xl leading-tight">
                      {t(c.titleKey)}
                    </h3>
                    <p className="mt-4 text-white/70 text-base md:text-lg leading-relaxed max-w-md">
                      {t(c.bodyKey)}
                    </p>
                  </div>
                </div>
              </div>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};

export default Manifesto;
